import React, { Component } from "react";

const Content = (props) => {
  return (
    <div className="sl__modal-inner">
      <div className="sl__modal--content">
        <div className="sl__modal--row">{props.children}</div>
      </div>
    </div>
  );
};

export default Content;
